module.exports = __webpack_public_path__ + "media/images/faces/male/8-1f5e7120ed3516771a7a93e770cf65ef.jpg";